import { useContext, useEffect, useState } from "react";
import { UserContext } from "../UserContext";
import { error as logError } from "../logger";

export function useIsInternalCohereUser(): boolean | undefined {
  const [userOpsGroup, setUserOpsGroup] = useState<string | undefined>();
  const { getUser } = useContext(UserContext);
  useEffect(() => {
    getUser()
      ?.then((user) => {
        setUserOpsGroup(user?.opsGroup);
      })
      .catch((e) => {
        logError(e);
      });
  }, [getUser]);
  return userOpsGroup
    ? ["COHERE", "COHERE_ADMIN", "COHERE_CLINICAL_OPS", "COHERE_MD"].includes(userOpsGroup.toUpperCase() || "")
    : undefined;
}
